import _ from 'lodash';
import React, { Component } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import ProjectList from '../Projects/ProjectList';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import './Profile.css';
import { GOOGLE_API_KEY } from '../../environment';
import MapContainer from '../Maps/MapContainer3.js';

class Profile extends Component {
    componentDidMount() {
        this.props.fetchScreenDonorProfile();
    }

    renderMyFavourites() {
        const { favourites } = this.props.screens.donorprofile;
        if (!favourites) {
            return (
                <div style={{marginTop: 15}} className="tikki-list-main">
                    <h1>Saved Projects</h1>
                    <div className="tikki-list-separator" />
                </div>
            );
        } else {
            return (
                <ProjectList projects={favourites} title="Saved Projects" />
            );
        }
    }

    renderMyProjects() {
        const { projects } = this.props.screens.donorprofile.donations;
        if (!projects) {
            return (
                <div style={{marginTop: 15}} className="tikki-list-main">
                    <h1>My Projects</h1>
                    <div className="tikki-list-separator" />
                </div>
            );
        } else {
            return (
                <ProjectList projects={projects} title="My Projects" />
            );
        }
    }

    renderMyImpact() {
        const { stats } = this.props.screens.donorprofile.donations;
        if (!stats) {
            return (
                <div className="profile-myimpact">
                    <h3>My Impact</h3>
                    <div className="tikki-list-separator" />
                    <div className="profile-myimpact-stats">
                        <div className="about-team-avatar">
                            <div className="tikki-team-container">
                                <span className="profile-myimpact-value">$0</span>
                                <br />
                                <span className="profile-myimpact-name">Donated</span>
                            </div>
                        </div>
                        <div className="about-team-avatar">
                            <div className="tikki-team-container">
                                <span className="profile-myimpact-value">0</span>
                                <br />
                                <span className="profile-myimpact-name">Projects</span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            const { stats, projects } = this.props.screens.donorprofile.donations;
            const donationsAmount = stats.donationsAmount / 100;
            return (
                <div className="profile-myimpact">
                    <h3>My Impact</h3>
                    <div className="tikki-list-separator" />
                    <div className="profile-myimpact-stats">
                        <div className="about-team-avatar">
                            <div className="tikki-team-container">
                                <span className="profile-myimpact-value">${donationsAmount.toLocaleString('en')}</span>
                                <br />
                                <span className="profile-myimpact-name">Donated</span>
                            </div>
                        </div>
                        <div className="about-team-avatar">
                            <div className="tikki-team-container">
                                <span className="profile-myimpact-value">{projects.length}</span>
                                <br />
                                <span className="profile-myimpact-name">Projects</span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    renderMap() {
        const googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&v=3.exp&libraries=geometry,drawing,places`;
        const { markers } = this.props.screens.donorprofile.donations;
        if (!markers) {
            return (
                <div style={{height: '400px', width: '100%'}}>
                    <MapContainer
                        mapMarkers={[]}
                        googleMapURL={googleMapURL}
                        containerElement={<div style={{ width: "100%", height: "100%" }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                        loadingElement={<div style={{ height: `100%` }} />}
                    />
                </div>
            );
        } else {
            return (
                <div style={{height: '400px', width: '100%'}}>
                    <MapContainer
                        mapMarkers={markers}
                        googleMapURL={googleMapURL}
                        containerElement={<div style={{ width: "100%", height: "100%" }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                        loadingElement={<div style={{ height: `100%` }} />}
                    />
                </div>
            );
        }
    }

    renderProjectUpdates() {
        const { projectFeed } = this.props.screens.donorprofile;
        if (!projectFeed) {
            return (
                <div className="profile-myimpact">
                    <h3>Project Updates</h3>
                    <div className="tikki-list-separator" />
                </div>
            );
        } else {
            return (
                <div className="profile-myimpact">
                    <h3>Project Updates</h3>
                    <div className="tikki-list-separator" />
                </div>
            );
        }
    }

    render () {
        const { auth } = this.props;
        const { name } = this.props.user;
        const { isAuthenticated } = this.props.auth;

        return (
            <div className="profile-container">
                <Header auth={auth} />
                {
                    isAuthenticated() && (
                        <div>
                            <div className="profile-main">
                                <div className="profile-section-one tikki-shadow">
                                    <div className="profile-card-outer tikki-shadow">
                                        <img className="profile-card-img" src={this.props.user.picture} alt=""></img>
                                    </div>
                                    <div className="profile-myimpact">
                                        <h1>{name}</h1>
                                        <div className="tikki-list-separator" />
                                    </div>
                                    {this.renderMyImpact()}
                                </div>
                                <div className="profile-section-two tikki-shadow">
                                    {this.renderProjectUpdates()}
                                </div>
                            </div>
                            <div className="profile-mydonateprojects-container">
                                {this.renderMyProjects()}
                                {this.renderMap()}
                            </div>
                            <div className="profile-mysavedprojects-container">
                                {this.renderMyFavourites()}
                            </div>
                        </div>
                    )
                }
                {
                    !isAuthenticated() && (
                        <div className="profile-main tikki-shadow">
                            <div className="profile-section tikki-paragraph">
                                <span>
                                    You must login to continue.
                                </span>
                            </div>
                        </div>
                    )
                }
                <Footer />
            </div>
        );
    };
};

function mapStateToProps({ user, screens, projects }) {
    return { user, screens, projects };
}

export default connect(mapStateToProps, actions)(Profile);



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js